import { useEffect, useRef } from "react";
export const useDeleteElementMutationObserver = ({ elementId, isMutationObserverActive, }) => {
    const mutationObserverRef = useRef(null);
    useEffect(() => {
        if (!isMutationObserverActive) {
            mutationObserverRef.current?.disconnect();
            return;
        }
        mutationObserverRef.current = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                if (mutation.type === "childList") {
                    mutation.removedNodes.forEach((node) => {
                        if (node instanceof HTMLElement && node.id === elementId) {
                            window.location.reload();
                        }
                    });
                }
            });
        });
        mutationObserverRef.current.observe(document.body, {
            childList: true,
            subtree: true,
        });
        return () => mutationObserverRef.current.disconnect();
    }, [elementId, isMutationObserverActive]);
};
//# sourceMappingURL=useDeleteElementMutationObserver.js.map